import { render, staticRenderFns } from "./SelectInputResourcefulV3.vue?vue&type=template&id=55ab1694&scoped=true&"
import script from "./SelectInputResourcefulV3.vue?vue&type=script&lang=js&"
export * from "./SelectInputResourcefulV3.vue?vue&type=script&lang=js&"
import style0 from "./SelectInputResourcefulV3.vue?vue&type=style&index=0&id=55ab1694&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ab1694",
  null
  
)

export default component.exports